import { Alert } from "../../model";
import { Action, ActionType } from "../../model/actionType";
import createReducer from "./createReducer";

export const alert = createReducer<Alert>({ message: "", statusCode: 200 }, {
	[ActionType.ALERT](state: Alert, action: Action<Alert>) {
		return action.payload;
	}
});
